import React, { PropTypes } from 'react';
import classNames from 'classnames';
import './IngredientIcon.less';


const IngredientIcon = (props) => {
  const classes = classNames('ingredient-icon', props.className);
  return (
    <figure className={classes} />
  );
};

IngredientIcon.propTypes = {
  className: PropTypes.string
};

export default IngredientIcon;



// WEBPACK FOOTER //
// ./src/components/Ingredients/IngredientIcon.js